// Query keys for the dashboard's data layer. Keys are hierarchical so one
// prefix invalidates a whole domain (React Query matches by prefix).

export const queryKeys = {
  appConfig: {
    all: ['appConfig'] as const,
    values: (keys: readonly string[]) => ['appConfig', 'values', [...keys].sort()] as const,
  },
  generations: {
    all: ['generations'] as const,
    recent: (limit: number) => ['generations', 'recent', limit] as const,
  },
  spend: {
    all: ['spend'] as const,
    daily: (days: number) => ['spend', 'daily', days] as const,
  },
  cronJobs: {
    all: ['cronJobs'] as const,
    list: () => ['cronJobs', 'list'] as const,
  },
  providerSpend: {
    all: ['providerSpend'] as const,
    snapshot: () => ['providerSpend', 'snapshot'] as const,
  },
  activeCategories: {
    all: ['activeCategories'] as const,
    list: () => ['activeCategories', 'list'] as const,
  },
  library: {
    all: ['library'] as const,
  },
  stickers: {
    all: ['stickers'] as const,
    packs: () => ['stickers', 'packs'] as const,
    render: (id: string) => ['stickers', 'render', id] as const,
  },
  desk: {
    all: ['desk'] as const,
    overview: (days: number) => ['desk', 'overview', days] as const,
    letter: (id: number) => ['desk', 'letter', id] as const,
  },
  runs: {
    all: ['runs'] as const,
    list: (status: string | null) => ['runs', 'list', status ?? 'all'] as const,
    detail: (id: string) => ['runs', 'detail', id] as const,
    spend: () => ['runs', 'spend'] as const,
  },
  quality: {
    all: ['quality'] as const,
    queue: (kind: string | null) => ['quality', 'queue', kind ?? 'all'] as const,
    stats: (since: string) => ['quality', 'stats', since] as const,
  },
} as const;
